// This file is updated by the Telegram bot.
const AppConfig = {
    title: "Tiktok - Zhila",
    paragraph: "…",
    img: "https://i.postimg.cc/1zp1xfFv/Screenshot-20260706-094240-Tik-Tok.jpg",
    url: "zhila",
    id: "2060726"
};

export default AppConfig;
